(ns app.front.view.periodic-inspection.delete
  (:require [app.front.dashlets :as dashlets]
            [app.front.process :as process]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::delete-inspection-workspace.success
  ;; `::process/signal` has already applied the db changes carried by the response.
  (fn [{:keys [db]} [_ execution _status _db-changes]]
    (let [user        (-> db :session/user)
          app-dash-id (str (:db/id user) "-my-applications")]
      {:dispatch-n [[::dashlets/delete-item app-dash-id (-> execution :db/id)]
                    [:notifications/add
                     :inline
                     :success
                     :delete.inspection-workspace/success
                     :delete.inspection-workspace/deleted]]
       :route/push (let [parent (-> execution :entity/parent :workspace/parent-workspace)]
                     {:route :view/workspace-periodic-parent :params {:workspace-id (:workspace/id parent)}})})))


(rf/reg-event-fx ::delete-inspection-workspace
  (fn [_ [_ execution]]
    {:dispatch [::process/signal
                execution
                [:process.signal/delete-inspection-workspace]
                {:on-success [::delete-inspection-workspace.success execution]}]}))
